import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FileList } from "./FileList";
import { useFileManager } from "../hooks/useFileOperations";
export function FileManager({ workspaceId, taskId, onFileUpload, onFileDownload, onFileDelete, showUpload = true, }) {
    const { files, error, isLoading, downloadFile, deleteFile, isDownloading, isDeleting } = useFileManager(workspaceId, taskId);
    const handleDownload = async (file) => {
        try {
            const result = await downloadFile(file.id);
            if (result.success) {
                onFileDownload?.(file);
            }
            else {
                console.error("Download failed:", result.error);
                // You might want to show a toast notification here
            }
        }
        catch (error) {
            console.error("Download error:", error);
        }
    };
    const handleDelete = async (file) => {
        try {
            const result = await deleteFile(file.id);
            if (result.success) {
                onFileDelete?.(file);
            }
            else {
                console.error("Delete failed:", result.error);
                // You might want to show a toast notification here
            }
        }
        catch (error) {
            console.error("Delete error:", error);
        }
    };
    const handleUpload = (file) => {
        onFileUpload?.(file);
    };
    if (error) {
        return (_jsxs("div", { className: "rounded-lg border border-red-200 bg-red-50 p-4", children: [_jsxs("div", { className: "flex items-center space-x-2", children: [_jsx("span", { className: "text-red-600", children: "\u274C" }), _jsx("span", { className: "text-red-700", children: "Failed to load files" })] }), _jsx("p", { className: "mt-1 text-sm text-red-600", children: error instanceof Error ? error.message : "An error occurred" })] }));
    }
    return (_jsxs("div", { className: "space-y-4", children: [_jsx(FileList, { workspaceId: workspaceId, taskId: taskId, files: files, loading: isLoading, onUpload: handleUpload, onDownload: handleDownload, onDelete: handleDelete, showUpload: showUpload }), (Object.keys(isDownloading).some((key) => isDownloading[key]) ||
                Object.keys(isDeleting).some((key) => isDeleting[key])) && (_jsx("div", { className: "fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-25", children: _jsx("div", { className: "rounded-lg bg-white p-4 shadow-lg", children: _jsxs("div", { className: "flex items-center space-x-3", children: [_jsx("div", { className: "h-6 w-6 animate-spin rounded-full border-b-2 border-blue-600" }), _jsx("span", { className: "text-gray-700", children: "Processing..." })] }) }) }))] }));
}
